"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
function useLayerStack(count) {
    if (count === void 0) { count = 1; }
    var _a = react_1.useState(0), index = _a[0], setIndex = _a[1];
    function push() {
        setIndex(Math.min(index + 1, count));
    }
    function pop() {
        setIndex(Math.max(index - 1, 0));
    }
    return [index, push, pop];
}
exports.default = useLayerStack;
//# sourceMappingURL=useLayerStack.js.map

//# sourceMappingURL={"version":3,"file":"useLayerStack.js","sourceRoot":"","sources":["useLayerStack.tsx"],"names":[],"mappings":";;AAAA,+BAAgC;AAEhC,SAAS,aAAa,CAAE,KAAiB;IAAjB,sBAAA,EAAA,SAAiB;IAE/B,IAAA,wBAAkC,EAAhC,aAAK,EAAE,gBAAyB,CAAA;IAExC,SAAS,IAAI;QAET,QAAQ,CAAE,IAAI,CAAC,GAAG,CAAE,KAAK,GAAG,CAAC,EAAE,KAAK,CAAC,CAAC,CAAA;IAC1C,CAAC;IAED,SAAS,GAAG;QAER,QAAQ,CAAE,IAAI,CAAC,GAAG,CAAE,KAAK,GAAG,CAAC,EAAE,CAAC,CAAC,CAAC,CAAA;IACtC,CAAC;IAED,OAAO,CAAE,KAAK,EAAE,IAAI,EAAE,GAAG,CAAE,CAAA;AAC/B,CAAC;AAED,kBAAe,aAAa,CAAA"}